import { PAL } from "../platform/PlatformAdapters";
export class LocalStorage {
    static setItem(key, value) {
        PAL.storage.setItem(key, value);
    }
    static getItem(key) {
        return PAL.storage.getItem(key);
    }
    static setJSON(key, value) {
        PAL.storage.setItem(key, JSON.stringify(value));
    }
    static getJSON(key) {
        return JSON.parse(PAL.storage.getItem(key));
    }
    static removeItem(key) {
        PAL.storage.removeItem(key);
    }
    static clear() {
        PAL.storage.clear();
    }
    static get count() {
        return PAL.storage.getCount();
    }
}
